import {
  Box,
  Button as MuiButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Paper,
  Modal,
} from "@mui/material";
import { FaArrowLeftLong, FaFileExport } from "react-icons/fa6";
import { FaEdit } from "react-icons/fa";
import { MdOutlineFileCopy } from "react-icons/md";
import { GrClose } from "react-icons/gr";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useCompany } from "../hooks/hooks";
import { Button, Form, InputGroup, Modal as RModal } from "react-bootstrap";
import { Menu, MenuItem } from "@mui/material";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

import {
  VpnKey as VpnKeyIcon,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";

import ExcelDownloadButton from "../utils/ExcelDownloader";
import CopyToClipboard from "react-copy-to-clipboard";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};

export const Licenses = () => {
  const { company } = useCompany();
  const { id } = useParams();
  const navigate = useNavigate();

  const [licenses, setLicenses] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedLicense, setSelectedLicense] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [showSurrender, setShowSurrender] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const [open, setOpen] = useState(false);
  const [token, setToken] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [copied, setCopied] = useState(false);

  const handleOpen = (value) => {
    setToken(value);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditMode(false);
    setShowToken(false);
  };

  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "#fff",
  };

  const handleMenuClose = () => setAnchorEl(null);

  const fetchLicenses = async () => {
    try {
      const res = await axios.get(
        `https://application.eterp.in/license/master/${id}`
      );
      setLicenses(res.data.data === null ? [] : [{ ...res.data.data }]);
    } catch (err) {
      console.error(err);
    }
  };

  const addLicense = async () => {
    setIsLoading(true);
    try {
      const res = await axios.post(
        `https://application.eterp.in/license/master`,
        { company_id: id, createdby: "Admin", lastupdatedby: "Admin" }
      );

      if (res?.data?.success) {
        toast(res.data.message);
        fetchLicenses();
      } else {
        toast("Please Add the Access first for the company!");
      }
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  const surrenderLicense = async () => {
    if (!password) return toast("Password is required");
    if (password !== "12345") return toast("Incorrect password");

    setIsLoading(true);
    try {
      const res = await axios.patch(
        `https://application.eterp.in/devices/surrender/master/${selectedLicense.license}`
      );
      toast(res.data.message);
      fetchLicenses();
      setShowSurrender(false);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLicenses();
  }, []);

  return (
    <Box sx={{ padding: 3 }}>
      <ToastContainer />

      {/* Top bar: Back + Company Name + Add/Export */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          marginBottom: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <FaArrowLeftLong
            size={28}
            color="#2db7e8"
            style={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            {company.name}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          {licenses?.length === 0 && (
            <MuiButton
              variant="contained"
              color="primary"
              onClick={addLicense}
              disabled={licenses.length !== 0}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
              }}
            >
              {isLoading ? (
                <ClipLoader color="#fff" size={18} cssOverride={override} />
              ) : (
                "Add License"
              )}
            </MuiButton>
          )}
          {/* <MuiButton
            variant="outlined"
            startIcon={<FaFileExport />}
            sx={{
              borderColor: "#2db7e8",
              color: "#2db7e8",
              borderRadius: 2,
              textTransform: "none",
              "&:hover": { backgroundColor: "#e0f7fa" },
            }}
            onClick={() => toast("Export functionality coming soon")}
          >
            Export
          </MuiButton> */}

          <ExcelDownloadButton
            data={licenses.map(
              ({
                license,
                license_date,
                mobile_no,
                device_id,
                manufacturer,
                is_expire,
                creator,
              }) => ({
                License: license,
                "License Date": license_date,
                "Mobile No": mobile_no,
                "Device Id": device_id,
                Manufacturer: manufacturer,
                Expire: is_expire ? "Expire" : "Not Expire",
                Creator: creator,
              })
            )}
            fileName={`${company.name} - License Details`}
          />
        </Box>
      </Box>

      {/* Table */}
      <TableContainer
        component={Paper}
        sx={{ borderRadius: 2, overflow: "hidden" }}
      >
        <Table>
          <TableHead sx={{ backgroundColor: "#2db7e8" }}>
            <TableRow>
              {[
                "License",
                "License Date",
                // "Mobile No",
                // "Device Id",
                // "Manufacturer",
                "Expire",
                "Creator",
                "Secret Key",
              ].map((col) => (
                <TableCell key={col} sx={{ color: "#fff", fontWeight: 600 }}>
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {licenses.map((row) => (
              <TableRow key={row.id} hover>
                <TableCell>{row.license}</TableCell>
                <TableCell>{row.license_date}</TableCell>
                {/* <TableCell>{row.mobile_no}</TableCell>
                <TableCell>{row.device_id}</TableCell>
                <TableCell>{row.manufacturer}</TableCell> */}
                <TableCell>{row.is_expire ? "Expire" : "Not Expire"}</TableCell>
                <TableCell>{row?.createdby}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleOpen(row?.token)}>
                    <VpnKeyIcon />
                  </IconButton>
                </TableCell>
                {/* <TableCell>
                  <BsThreeDotsVertical
                    size={22}
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleMenuClick(e, row)}
                  />
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Menu */}
      {/* <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{ horizontal: "right" }}
        transformOrigin={{ horizontal: "right" }}
      >
        <Button
          variant="text"
          onClick={() => {
            handleMenuClose();
            setOpenEdit(true);
          }}
        >
          Edit
        </Button>
        <Button
          variant="text"
          onClick={() => {
            handleMenuClose();
            setShowSurrender(true);
          }}
        >
          Surrender License
        </Button>
      </Menu> */}

      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleMenuClose}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        PaperProps={{
          sx: {
            borderRadius: 2,
            boxShadow: "0px 5px 15px rgba(0,0,0,0.2)",
            minWidth: 180,
            paddingY: 0.5,
          },
        }}
      >
        <MenuItem
          onClick={() => {
            handleMenuClose();
            setOpenEdit(true);
          }}
          sx={{
            borderRadius: 1,
            marginX: 1,
            marginY: 0.5,
            "&:hover": {
              backgroundColor: "#e0f7fa",
              color: "#007c91",
            },
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <FaEdit size={16} />
          Edit
        </MenuItem>

        <MenuItem
          onClick={() => {
            handleMenuClose();
            setShowSurrender(true);
          }}
          sx={{
            borderRadius: 1,
            marginX: 1,
            marginY: 0.5,
            "&:hover": {
              backgroundColor: "#ffebee",
              color: "#d32f2f",
            },
            fontWeight: 500,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <FaFileExport size={16} />
          Surrender License
        </MenuItem>
      </Menu>

      {/* Edit License Modal */}
      <Modal open={openEdit} onClose={() => setOpenEdit(false)}>
        <Box sx={modalStyle}>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
            <Typography variant="h6">Update License</Typography>
            <GrClose
              style={{ cursor: "pointer" }}
              onClick={() => setOpenEdit(false)}
            />
          </Box>
          {/* Replace this with your edit form */}
          <Typography>Form to edit license info goes here</Typography>
        </Box>
      </Modal>

      {/* Surrender Modal */}
      <RModal show={showSurrender} onHide={() => setShowSurrender(false)}>
        <RModal.Header closeButton>
          <RModal.Title>Surrender Confirmation!</RModal.Title>
        </RModal.Header>
        <RModal.Body>
          Are you sure you want to surrender{" "}
          <strong>{selectedLicense.license}</strong> license?
          <InputGroup className="mt-3" size="sm">
            <Button variant="outline-secondary">Password</Button>
            <Form.Control onChange={(e) => setPassword(e.target.value)} />
          </InputGroup>
        </RModal.Body>
        <RModal.Footer>
          <Button variant="secondary" onClick={() => setShowSurrender(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={surrenderLicense}>
            Confirm
          </Button>
        </RModal.Footer>
      </RModal>

      <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Secret Token</DialogTitle>

        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            type={showToken ? "text" : "password"}
            value={token}
            disabled={!editMode}
            onChange={(e) => setToken(e.target.value)}
            InputProps={{
              endAdornment: (
                <IconButton onClick={() => setShowToken(!showToken)}>
                  {showToken ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              ),
            }}
          />
        </DialogContent>

        <DialogActions>
          <CopyToClipboard text={token} onCopy={() => setCopied(true)}>
            <MuiButton
              onClick={() => setEditMode(true)}
              startIcon={
                <MdOutlineFileCopy size={20} style={{ cursor: "pointer" }} />
              }
            >
              {copied ? "Copied" : "Copy"}
            </MuiButton>
          </CopyToClipboard>

          <MuiButton onClick={handleClose}>Close</MuiButton>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
